import { BlogsMetadata } from '../../../../constants/BlogsMetadata';
import { FontSize } from '../../../../constants/FontSize';
import { PageUrl } from '../../../../constants/PageUrl';
import { SectionId } from '../../../../constants/SectionId';
import { DiagnosisCta } from '../../../common/DiagnosisCta';
import LinkCard from '../../../common/LinkCard';
import MainButton from '../../atoms/MainButton';
import SectionTitle from '../../atoms/SectionTitle';
import styles from './index.module.scss';

const Blogs = () => (
  <section id={SectionId.BLOGS} className={styles.base}>
    <div className={styles['title-wrapper']}>
      <SectionTitle title="ブログ" />
      <p className={styles.description}>
        モンテッソーリ教育の考え方を元に、日々の子育てのヒントになるような情報を発信しています！
      </p>
    </div>
    <div className={styles['blog-cards-wrapper']}>
      {Object.entries(BlogsMetadata)
        .slice(1, 7)
        .map(([id, blogMetadata]) => (
          <LinkCard
            key={id}
            title={blogMetadata.title}
            description={blogMetadata.description}
            thumbnailUrl={blogMetadata.thumbnailUrl}
            href={blogMetadata.filePath}
          />
        ))}
    </div>
    <a href={PageUrl.BLOG_ROOT} target="_blank" rel="noopener noreferrer" aria-label="もっと見る">
      <MainButton isHighlight isHoverEffect buttonText="もっと見る" fontSizeType={FontSize.MEDIUM} />
    </a>
    <div className={styles['diagnosis-cta-wrapper']}>
      <DiagnosisCta />
    </div>
  </section>
);

export default Blogs;
